import { requiredValues, requiredFiles } from './values';

const invalidEmail = (email) => {
	return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
};

export const validate = (values) => {
	const errors = {};
	Object.keys(values).map((key) => {
		if(requiredValues[key]) {
			if(key.toLowerCase().indexOf('email') > -1 && invalidEmail(values[key])) {
				errors[key] = 'Netfang er ekki á réttu formi';
			} else if(values[key] === false) {
				errors[key] = 'Samþykki er nauðsynlegt fyrir því að hægt sé að leggja inn umsókn';
			} else if(values[key].length === 0) {
				errors[key] = 'Vinsamlegast fylltu út eftirfarandi upplýsingar';
			}
		}
	});
	return errors;
};

export const allRequiredFilesPresent = (files) => {
	let valid = true;

	Object.keys(requiredFiles).map((key) => {
		if(!files[key].files) valid = false;
	});

	return valid;
};

export default validate;
